function SouthKorea({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2159)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M21.5652 16.0007C21.5652 17.392 19.0736 20.8703 16 20.8703C12.9264 20.8703 10.4348 17.392 10.4348 16.0007C10.4348 12.9271 12.9264 10.4355 16 10.4355C19.0736 10.4355 21.5652 12.9271 21.5652 16.0007Z" fill="#D80027"/>
  <path d="M21.5652 16C21.5652 19.0736 19.0736 21.5652 16 21.5652C12.9264 21.5652 10.4348 19.0736 10.4348 16" fill="#0052B4"/>
  <path d="M21.8984 20.9199L23.3739 19.4445L24.3576 20.4281L22.8821 21.9036L21.8984 20.9199Z" fill="black"/>
  <path d="M19.4386 23.3789L20.9141 21.9034L21.8977 22.8871L20.4223 24.3626L19.4386 23.3789Z" fill="black"/>
  <path d="M24.8496 23.8691L26.3251 22.3937L27.3087 23.3773L25.8333 24.8528L24.8496 23.8691Z" fill="black"/>
  <path d="M22.3898 26.3301L23.8652 24.8546L24.8489 25.8383L23.3734 27.3137L22.3898 26.3301Z" fill="black"/>
  <path d="M23.3739 22.3945L24.8494 20.9191L25.833 21.9027L24.3576 23.3782L23.3739 22.3945Z" fill="black"/>
  <path d="M20.9148 24.8535L22.3903 23.378L23.3739 24.3617L21.8985 25.8372L20.9148 24.8535Z" fill="black"/>
  <path d="M24.8561 11.084L20.9215 7.1494L21.9051 6.16574L25.8397 10.1003L24.8561 11.084Z" fill="black"/>
  <path d="M20.9208 10.0996L19.4453 8.62415L20.4289 7.64053L21.9044 9.116L20.9208 10.0996Z" fill="black"/>
  <path d="M23.3799 12.5605L21.9044 11.0851L22.888 10.1015L24.3635 11.5769L23.3799 12.5605Z" fill="black"/>
  <path d="M23.8715 7.14844L22.396 5.67297L23.3797 4.68931L24.8551 6.16478L23.8715 7.14844Z" fill="black"/>
  <path d="M26.3319 9.60938L24.8564 8.13391L25.8401 7.15025L27.3156 8.62572L26.3319 9.60938Z" fill="black"/>
  <path d="M5.67212 22.3926L9.6067 26.3272L8.62304 27.3108L4.68846 23.3762L5.67212 22.3926Z" fill="black"/>
  <path d="M9.60657 23.375L11.082 24.8505L10.0984 25.8341L8.62296 24.3586L9.60657 23.375Z" fill="black"/>
  <path d="M7.14722 20.916L8.62268 22.3915L7.63902 23.3751L6.16356 21.8997L7.14722 20.916Z" fill="black"/>
  <path d="M8.6228 19.4395L12.5574 23.374L11.5737 24.3577L7.63914 20.4231L8.6228 19.4395Z" fill="black"/>
  <path d="M9.60632 5.66992L5.67174 9.60451L4.68808 8.62085L8.62267 4.68626L9.60632 5.66992Z" fill="black"/>
  <path d="M11.0818 7.14648L7.1472 11.0811L6.16354 10.0974L10.0981 6.16283L11.0818 7.14648Z" fill="black"/>
  <path d="M12.5587 8.62109L8.62413 12.5557L7.64051 11.5721L11.5751 7.63748L12.5587 8.62109Z" fill="black"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default SouthKorea;
